import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './CardCell.module.scss';
import { CardCellProps } from './CardCell.types';

export const CardCell = forwardRef<HTMLDivElement, CardCellProps>(
  ({ className, tdClassName, align, pinned, pinDistance, style, children, ...props }, ref) => (
    <div
      ref={ref}
      className={classnames(styles.container, tdClassName, pinned && styles[pinned])}
      data-role="td"
      style={{
        ...style,
        // @ts-expect-error ---
        ['--pin-distance']: (pinDistance ?? 0) + 'px',
      }}
      {...props}
    >
      <div className={classnames(styles.content, align && styles[align], className)}>
        {children}
      </div>
    </div>
  )
);
